import { ActivatedRouteSnapshot, CanDeactivateFn, RouterStateSnapshot } from '@angular/router';
import { UserEditPageComponent } from './user-edit-page.component';

export const canDeactivateUserEditPage: CanDeactivateFn<UserEditPageComponent> = (
  component,
  currentRoute,
  _currentState,
  nextState,
) => {
  if (!component.hasUnsavedChanges || staysOnPage(currentRoute, nextState)) {
    return true;
  }
  return component.confirmDeactivate();
};

// „Einladung erneut senden“ zieht die URL auf die neue Einladung nach. Eine Rückfrage mitten darin
// ließe bei „Weiter bearbeiten“ die URL auf der bereits widerrufenen Einladung stehen.
function staysOnPage(currentRoute: ActivatedRouteSnapshot | null, nextState: RouterStateSnapshot | null): boolean {
  let leaf = nextState?.root;
  while (leaf?.firstChild) {
    leaf = leaf.firstChild;
  }
  const target = leaf?.routeConfig;
  return !!target && target === currentRoute?.routeConfig;
}
